var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPinTimeplaceLtr = function SvgPinTimeplaceLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m57.219 50.719-10.75-8.688V28h6.25v11.063l8.437 6.812z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.938 24.281c3.874-3.5 9-5.656 14.624-5.656v-.031c12.032 0 21.844 9.812 21.844 21.844 0 12.03-9.812 21.843-21.844 21.843-12.03 0-21.843-9.812-21.843-21.843 0-4.188 1.187-8.063 3.218-11.376l4.907 4.094c-1.157 2.188-1.875 4.625-1.875 7.282 0 8.593 7 15.593 15.593 15.593s15.594-7 15.594-15.593-7-15.594-15.594-15.594c-3.687 0-7.03 1.343-9.718 3.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M83.188 39.594C83.188 21.063 68.125 6 49.594 6S16 21.063 16 39.594c0 7.218 2.25 14.062 6.5 19.875l.063.062 27.093 33.782 26.5-33.125.094-.094.156-.188C80.875 54.031 83.25 47 83.25 39.594zM71.25 56.28 49.594 83.344 27.5 55.78a27.15 27.15 0 0 1-5.312-16.187c0-15.094 12.28-27.344 27.343-27.344S76.875 24.53 76.875 39.593c0 6.093-1.969 11.875-5.687 16.687z",
    clipRule: "evenodd"
  })));
};
export default SvgPinTimeplaceLtr;